module.exports = __webpack_public_path__ + "static/media/BIL_darker.7565048b.webp";